<template>
  <v-bottom-navigation
  v-if="visible"
  class="mb-2"
  v-bind:color="config.footer"
  flat
  >
    <v-toolbar
      v-bind:color="config.footer"
      dark
    >
      <span class="subheading">Website by Vitrical </span>

      <v-divider
        class="mx-4"
        vertical
      ></v-divider>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn dark text @click="navigateTo({name: 'about'})">
          <span :class="config.secondary_text == 'white' ? 'white--text' : 'black--text'" >About</span>
        </v-btn>

        <v-divider vertical></v-divider>

        <v-btn text @click="alertUser()">
          <span :class="config.secondary_text == 'white' ? 'white--text' : 'black--text'" >Support</span>
        </v-btn>

        <v-divider vertical></v-divider>

        <v-btn text @click="navigateTo({name: 'legal'})">
          <span :class="config.secondary_text == 'white' ? 'white--text' : 'black--text'" >Legal</span>
        </v-btn>

        <v-divider vertical></v-divider>
      </v-toolbar-items>
    </v-toolbar>
  </v-bottom-navigation>
</template>

<script>
import config from '@/config/config'
export default {
  name: 'bottom-footer',
  data() {
    return {
      config,
      visible: true
    }
  },
  methods: {
    alertUser() {
      alert('This page is under construction. Please email sales@chipcustomizer.com for assistance. Thank you.')
    },
    navigateTo (route) {
      this.$router.push(route)
    },
    logOut () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$router.push({
        name: 'root'
      })
    }
  },
  mounted () {
    if (this.$route.name == 'changepassword') {
      this.visible = false
    } else {
      this.visible = true
    }
  }
}
</script>

<style scoped>

</style>